import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || '';

const axiosInstance = axios.create({
  baseURL: API_BASE,
});

// Интерцептор для добавления токена из localStorage
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const fetchProducts = async () => {
  const response = await axiosInstance.get('/api/v1/products');
  return response.data.data;
};

export const fetchOpenBox = async (cellName) => {
  const response = await axiosInstance.put(`/api/v1/box/${cellName}/open`);
  return response;
};

export const fetchLightSwitchBox = async (cellName) => {
  const response = await axiosInstance.put(`/api/v1/box/${cellName}/light/1`);
  return response;
};


export const createProduct = async (product) => {
  const response = await axiosInstance.post('/api/v1/products', product);
  return response.data;
};

export const fetchCategories = async () => {
  const response = await axiosInstance.get('/api/v1/categories');
  return response.data.data;
};

export const createCategory = async (category) => {
  const response = await axiosInstance.post('/api/v1/categories', category);
  return response.data;
};


export const patchProduct = async (productId, bouquetId) => {
  const response = await axiosInstance.patch(
    `/api/v1/products/${productId}`,
    bouquetId
  );
  return response.data;
};

export const fetchByket = async () => {
  const response = await axiosInstance.get('/api/v1/byket');
  return response.data.data;
};

export const createByket = async (byket) => {
  const response = await axiosInstance.post('/api/v1/byket', byket);
  return response.data;
};

export const loginUser = async (email, password) => {
  const response = await axios.post(
    `${API_BASE}/api/v1/user/login`,
    new URLSearchParams({
      username: email,
      password: password,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return response.data;
};
